import React from 'react';
import styled from 'styled-components';

import { WrappedMenu } from './new/Menu';

import { CustomBreadCrumbs } from './new/CustomBreadCrumbs';

import headerBg from '../images/blog/white-wave.svg';
import { Container } from './Container';
import { BaseHeadingStyle } from './new/headers';

// const MenuWrap = styled.div`
//     padding: 16px 0;
//     margin-bottom: 48px;
//     box-sizing: border-box;
//     display: flex;
//     align-items: flex-start;
// `;

const ArticleHeaderWrapper = styled.div`
    position: relative;
    height: 627px;
    background-image: url(${props => props.backgroundImageSrc});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 0;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.65);
    }

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 122px;
        background-image: url(${headerBg});
    }

    @media screen and (max-width: 760px) {
        height: 498px;
    }
`;

const ArticleHeading = styled.div`
    display: block;
    padding: 0 112px; // 80px + 32px
    box-sizing: border-box;

    .article-heading__meta {
        position: relative;
        z-index: 5;
    }

    .article-heading__breadcrumbs-item,
    .article-heading__breadcrumbs-item a {
        font-family: 'Circe Web';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 140%;
        color: rgba(0, 0, 0, 0.6);
    }

    .article-heading__breadcrumbs-item {
        & + .article-heading__breadcrumbs-item {
            &:before {
                content: '>';
                display: inline-block;
                padding-right: 17px;
                margin-left: 17px;
            }

            @media screen and (max-width: 760px) {
                &:before {
                    content: '<';
                    margin-left: 0;
                }
            }
        }

        @media screen and (max-width: 760px) {
            &:first-child {
                display: none;
            }
        }
    }

    .article-heading__section {
        background: #fff;
        border-radius: 8px;
        font-family: 'Circe Web';
        font-size: 18px;
        line-height: 140%;
        color: rgba(0, 0, 0, 0.6);
        padding: 0 16px;
        box-sizing: border-box;
        margin-left: 80px;

        @media screen and (max-width: 760px) {
            margin-left: 32px;
        }
    }

    .article-heading__title {
        max-width: 980px;
        margin-bottom: 32px;

        @media screen and (max-width: 760px) {
            margin: 8px 0 24px;
        }
    }

    .article-heading__published-date {
        font-family: 'Circe Web';
        font-size: 18px;
        line-height: 140%;

        @media screen and (max-width: 760px) {
            font-size: 16px;
            line-height: 150%;
            display: inline-block;
            width: 100%;
        }
    }

    @media screen and (max-width: 1200px) {
        padding: 0;
    }
`;

const H1 = styled(BaseHeadingStyle)`
    font-size: 80px;
    line-height: 100%;
    position: relative;
    left: -3px;

    @media screen and (max-width: 760px) {
        font-size: 38px;
        margin: 24px 0 16px;
    }
`;

export const ArticleHeader = ({ title, date, imageSrc }) => {
    const crumbs = [
        { pathname: '/', crumbLabel: 'КЭСПА' },
        { pathname: '/blog', crumbLabel: 'Блог' },
    ];

    return (
        <ArticleHeaderWrapper backgroundImageSrc={imageSrc}>
            <Container>
                <WrappedMenu />

                <ArticleHeading>
                    <CustomBreadCrumbs crumbs={crumbs} />
                    <H1 as="h1" className="article-heading__title">
                        {title}
                    </H1>
                    <div>
                        <span className="article-heading__published-date">
                            {date}
                        </span>
                    </div>
                </ArticleHeading>
            </Container>
        </ArticleHeaderWrapper>
    );
};
